exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".change_text_color[data-v-16ad65a0]:hover {\n  color: #0f74a8;\n  text-decoration: underline;\n}\n", ""]);

// exports
